import { render } from "./SelectInput.vue?vue&type=template&id=12e45f82"
import script from "./SelectInput.vue?vue&type=script&lang=js"
export * from "./SelectInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__